import { setGetGroupOffersAction } from '../action';
import { getGroupOffers } from '../api/getGroupOffers';

export const setGetGroupOffers = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGroupOffers(params);
            dispatch(setGetGroupOffersAction({
                data: data.data,
                currentPage: data?.pagination?.currentPage,
                currentRowsPerpage: data?.pagination?.currentRowsPerPage,
                total: data?.pagination?.total,
                totalPage: data?.pagination?.totalPage
            }))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}